export const orders: TableModule = {
    name: 'orders',
    route: 'spa.projects.organisations.projects.orders',
    defaultOrder: {
        column: 'time_from',
        direction: 'desc',
    },
    routeParams: [
        {
            param: 'organisation',
            prop: 'organisation_id',
        },
        {
            param: 'project',
            prop: 'project_id',
        },
    ],
    columns: [
        {
            name: 'order_number',
            sortable: true,
            pageLink: true,
            mobile: true,
        },
        {
            name: 'time_from',
            sortable: true,
        },
        {
            name: 'status',
            sortable: true,
        },
        {
            name: 'contractor_name',
            sortable: false,
        },
        {
            name: 'created_at',
            sortable: true,
        },
    ],
    filters: [
        {
            name: 'id',
            column: 'orders.id',
            type: 'numeric',
        },
    ],
    quickFilters: [],
    tools: [],
}
